import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { governancePrivateRoutesConstants as routesConstants } from "./routesConstants";

// Pages
const GovernanceDashboard = lazy(() =>
  componentLazyImport(() => import("../../pages/GovernanceDashboard"))
);
const UserDetailsPage = lazy(() =>
  componentLazyImport(() => import("../../pages/UserDetails"))
);
const PeopleStats = lazy(() =>
  componentLazyImport(() => import("../../pages/PeopleStats"))
);
const Playbooks = lazy(() =>
  componentLazyImport(() => import("../../pages/Playbooks"))
);
const CreatePlaybook = lazy(() =>
  componentLazyImport(() => import("../../pages/CreatePlaybook"))
);
const EditPlaybook = lazy(() =>
  componentLazyImport(() => import("../../pages/EditPlaybook"))
);
const SinglePlaybook = lazy(() =>
  componentLazyImport(() => import("../../pages/SinglePlaybook"))
);
const GovernanceCenter = lazy(() =>
  componentLazyImport(() => import("../../pages/GovernanceCenter"))
);
const ExperimentTemplates = lazy(() =>
  componentLazyImport(() => import("../../pages/ExperimentTemplates"))
);
const ExperimentTemplate = lazy(() =>
  componentLazyImport(() => import("../../pages/ExperimentTemplate"))
);
const ExperimentStatuses = lazy(() =>
  componentLazyImport(() => import("../../pages/ExperimentStatuses"))
);
const ExperimentSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/ExperimentSettings"))
);
const ReportsTemplates = lazy(() =>
  componentLazyImport(() => import("../../pages/ReportsTemplates"))
);
const IdeasTemplates = lazy(() =>
  componentLazyImport(() => import("../../pages/IdeasTemplates"))
);
const IdeaTemplate = lazy(() =>
  componentLazyImport(() => import("../../pages/IdeaTemplate"))
);
const IdeasSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/IdeasSettings"))
);
const ResearchTemplates = lazy(() =>
  componentLazyImport(() => import("../../pages/ResearchTemplates"))
);
const ResearchTemplate = lazy(() =>
  componentLazyImport(() => import("../../pages/ResearchTemplate"))
);
const ResearchStatuses = lazy(() =>
  componentLazyImport(() => import("../../pages/ResearchStatuses"))
);
const TagManager = lazy(() =>
  componentLazyImport(() => import("../../pages/TagManager"))
);
const TagSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/TagSettings"))
);
const GoalSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/GoalsSettings"))
);
const GoalManager = lazy(() =>
  componentLazyImport(() => import("../../pages/GoalManager"))
);
const QueryManager = lazy(() =>
  componentLazyImport(() => import("../../pages/QueryManager"))
);
const CrowdsourceTemplate = lazy(() =>
  componentLazyImport(() => import("../../pages/CrowdsourceTemplate"))
);

const InsightsPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.governance_dashboard.path} exact>
        <GovernanceDashboard />
      </Route>

      <Route path={routesConstants.governance_center.path} exact>
        <GovernanceCenter />
      </Route>

      <Route path={routesConstants.experiment_templates.path} exact>
        <ExperimentTemplates />
      </Route>

      <Route path={routesConstants.experiment_template.path} exact>
        <ExperimentTemplate />
      </Route>

      <Route path={routesConstants.experiment_statuses.path} exact>
        <ExperimentStatuses />
      </Route>

      <Route path={routesConstants.experiment_settings.path} exact>
        <ExperimentSettings />
      </Route>

      <Route path={routesConstants.reports_templates.path} exact>
        <ReportsTemplates />
      </Route>

      <Route path={routesConstants.ideas_templates.path} exact>
        <IdeasTemplates />
      </Route>

      <Route path={routesConstants.idea_template.path} exact>
        <IdeaTemplate />
      </Route>

      <Route path={routesConstants.ideas_settings.path} exact>
        <IdeasSettings />
      </Route>

      <Route path={routesConstants.research_templates.path} exact>
        <ResearchTemplates />
      </Route>

      <Route path={routesConstants.research_template.path} exact>
        <ResearchTemplate />
      </Route>

      <Route path={routesConstants.research_statuses.path} exact>
        <ResearchStatuses />
      </Route>

      <Route path={routesConstants.tag_settings.path} exact>
        <TagSettings />
      </Route>

      <Route path={routesConstants.tag_manager.path} exact>
        <TagManager />
      </Route>

      <Route path={routesConstants.goals_settings.path} exact>
        <GoalSettings />
      </Route>

      <Route path={routesConstants.goal_manager.path} exact>
        <GoalManager />
      </Route>

      <Route path={routesConstants.query_manager.path} exact>
        <QueryManager />
      </Route>

      <Route path={routesConstants.crowdsource_template.path} exact>
        <CrowdsourceTemplate />
      </Route>

      <Route path={routesConstants.edit_playbook.path}>
        <EditPlaybook />
      </Route>

      <Route path={routesConstants.create_playbook.path}>
        <CreatePlaybook />
      </Route>

      <Route path={routesConstants.single_playbook.path}>
        <SinglePlaybook />
      </Route>

      <Route path={routesConstants.playbooks.path}>
        <Playbooks />
      </Route>

      <Route path={routesConstants.user_details.path} exact>
        <UserDetailsPage />
      </Route>

      <Route path={routesConstants.people_stats.path}>
        <PeopleStats />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default InsightsPrivateRoutes;
